export default class Options {
  static getValue = (field, key) => {
    const val = this[field]?.find(i => i.key === key) || null;
    return val?.value || key;
  };
  static getShort = (field, key) => {
    const val = this[field]?.find(i => i.key === key) || null;
    return val?.short || this.getValue(field, key);
  };
  static getLong = (field, key) => {
    const val = this[field]?.find(i => i.key === key) || null;
    return val?.long || this.getValue(field, key);
  };
  static fach = [
    {key: "e", value: "Evangelische Religionslehre", short: "Evang_RL"},
    {key: "k", value: "Katholische Religionslehre", short: "Kath_RL"},
    {key: "j", value: "Jüdische Religion und Philosophie", short: "Jued_RuP"}
  ];
  static kursart = [
    {key: "l", value: "Leistungskurs", short: "LK"},
    {key: "g", value: "Grundkurs", short: "GK"},
    {key: "e", value: "Einführungsphase", short: "EP"}
  ];
  static pruefungsart = [
    {key: "k", value: "Klausur"},
    {key: "a", value: "Abitur"},
    {key: "an", value: "Abitur-Nachschreibetermin"}
  ];
  static halbjahr = [
    {key: "e", value: "Einführungsphase"},
    {key: "sh1", value: "1. Kurs- / Schulhalbjahr", short: "1 HJ"},
    {key: "sh2", value: "2. Kurs- / Schulhalbjahr", short: "2 HJ"},
    {key: "sh3", value: "3. Kurs- / Schulhalbjahr", short: "3 HJ"},
    {key: "sh4", value: "4. Kurs- / Schulhalbjahr", short: "4 HJ"},
    {key: "sh5", value: "5. Schulhalbjahr", short: "5 HJ"},
    {key: "sh6", value: "6. Schulhalbjahr", short: "6 HJ"}
  ];
  static klausurnummer = [
    {key: "null", value: ""},
    {key: "k1", value: "1 Klausur"},
    {key: "k2", value: "2 Klausur"}
  ];
  static aufgabenart = [
    {key: "t", value: "Textaufgabe"},
    {key: "et", value: "Erweiterte Textaufgabe"},
    {key: "eo", value: "Erörterung"}
  ];
  static gutachter = [
    {key: "", value: ""},
    {key: "ga1", value: "Erstgutachter", long: "Erstgutachter/in"},
    {key: "ga2", value: "Zweitgutachter", long: "Zweitgutachter/in"}
  ];
}
